import { render, staticRenderFns } from "./PurifyDtlRpt.vue?vue&type=template&id=75767628&scoped=true&"
import script from "./PurifyDtlRpt.vue?vue&type=script&lang=js&"
export * from "./PurifyDtlRpt.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "75767628",
  null
  
)

export default component.exports